export default __webpack_public_path__ + "media/BusinessSupport.8aefed95.svg";